(function () {
  'use strict';

  var SELECTOR = '[data-tuuli-delivery-timeline]';
  var HANDLING_MIN = 0;
  var HANDLING_MAX = 3;

  var GROUP_AT_SI = ['AT', 'SI'];

  var GROUP_EU = [
    'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
    'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO',
    'SK', 'ES', 'SE'
  ];

  var GROUP_EUROPE = [
    'AL', 'AD', 'AM', 'BA', 'BY', 'CH', 'FO', 'GB', 'GE', 'GG', 'GI',
    'GL', 'IM', 'IS', 'JE', 'LI', 'MC', 'MD', 'ME', 'MK', 'NO', 'RS',
    'SM', 'TR', 'UA', 'VA'
  ];

  var DICTIONARY = {
    en: {
      ordered: 'Ordered',
      ready: 'Order Ready',
      delivered: 'Delivered',
      freeShip: 'Free Shipping to'
    },
    de: {
      ordered: 'Bestellt',
      ready: 'Versandbereit',
      delivered: 'Geliefert',
      freeShip: 'Kostenloser Versand nach'
    },
    fr: {
      ordered: 'Commandé',
      ready: 'Prêt',
      delivered: 'Livré',
      freeShip: 'Livraison gratuite vers'
    },
    it: {
      ordered: 'Ordinato',
      ready: 'Pronto',
      delivered: 'Consegnato',
      freeShip: 'Spedizione gratuita per'
    },
    es: {
      ordered: 'Pedido',
      ready: 'Listo',
      delivered: 'Entregado',
      freeShip: 'Envío gratis a'
    },
    sl: {
      ordered: 'Naročeno',
      ready: 'Pripravljeno',
      delivered: 'Dostavljeno',
      freeShip: 'Brezplačna dostava v'
    },
    hr: {
      ordered: 'Naručeno',
      ready: 'Spremno',
      delivered: 'Dostavljeno',
      freeShip: 'Besplatna dostava za'
    },
    cs: {
      ordered: 'Objednáno',
      ready: 'Připraveno',
      delivered: 'Doručeno',
      freeShip: 'Doprava zdarma do'
    },
    da: {
      ordered: 'Bestilt',
      ready: 'Klar',
      delivered: 'Leveret',
      freeShip: 'Gratis fragt til'
    },
    nl: {
      ordered: 'Besteld',
      ready: 'Klaar',
      delivered: 'Geleverd',
      freeShip: 'Gratis verzending naar'
    },
    fi: {
      ordered: 'Tilattu',
      ready: 'Valmis',
      delivered: 'Toimitettu',
      freeShip: 'Ilmainen toimitus maahan'
    },
    hu: {
      ordered: 'Megrendelve',
      ready: 'Kész',
      delivered: 'Kézbesítve',
      freeShip: 'Ingyenes szállítás ide:'
    },
    ja: {
      ordered: '注文済み',
      ready: '準備完了',
      delivered: '配達済み',
      freeShip: '送料無料：'
    },
    no: {
      ordered: 'Bestilt',
      ready: 'Klar',
      delivered: 'Levert',
      freeShip: 'Gratis frakt til'
    },
    pl: {
      ordered: 'Zamówiono',
      ready: 'Gotowe',
      delivered: 'Dostarczono',
      freeShip: 'Darmowa dostawa do'
    },
    pt: {
      ordered: 'Pedido',
      ready: 'Pronto',
      delivered: 'Entregue',
      freeShip: 'Envio grátis para'
    },
    ro: {
      ordered: 'Comandat',
      ready: 'Pregătit',
      delivered: 'Livrat',
      freeShip: 'Livrare gratuită în'
    },
    sk: {
      ordered: 'Objednané',
      ready: 'Pripravené',
      delivered: 'Doručené',
      freeShip: 'Doprava zdarma do'
    },
    sv: {
      ordered: 'Beställd',
      ready: 'Redo',
      delivered: 'Levererad',
      freeShip: 'Gratis frakt till'
    },
    tr: {
      ordered: 'Sipariş',
      ready: 'Hazır',
      delivered: 'Teslim',
      freeShip: 'Ücretsiz Kargo:'
    },
    uk: {
      ordered: 'Замовлено',
      ready: 'Готово',
      delivered: 'Доставлено',
      freeShip: 'Безкоштовна доставка до'
    },
    ar: {
      ordered: 'تم الطلب',
      ready: 'جاهز',
      delivered: 'تم التوصيل',
      freeShip: 'شحن مجاني إلى'
    },
    el: {
      ordered: 'Παραγγελία',
      ready: 'Έτοιμο',
      delivered: 'Παραδόθηκε',
      freeShip: 'Δωρεάν αποστολή σε'
    }
  };

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var count = 0;

    if (days === 0) {
      while (
        result.getDay() === 0 ||
        result.getDay() === 6
      ) {
        result.setDate(result.getDate() + 1);
      }

      return result;
    }

    while (count < days) {
      result.setDate(result.getDate() + 1);

      if (
        result.getDay() !== 0 &&
        result.getDay() !== 6
      ) {
        count += 1;
      }
    }

    return result;
  }

  function setText(container, selector, value) {
    var element = container.querySelector(selector);

    if (element) {
      element.textContent = value;
    }
  }

  function renderDestination(
    container,
    label,
    countryName
  ) {
    var target = container.querySelector(
      '[data-delivery-destination]'
    );

    if (!target) {
      return;
    }

    target.textContent = label + ' ';

    var strong = document.createElement('strong');
    strong.textContent = countryName;

    target.appendChild(strong);
  }

  function init(container) {
    if (
      !container ||
      container.dataset.deliveryTimelineReady === 'true'
    ) {
      return;
    }

    var currentCountry = String(
      container.dataset.country || ''
    ).toUpperCase();

    var currentLocale = String(
      container.dataset.locale || 'en'
    );

    var langCode = currentLocale
      .slice(0, 2)
      .toLowerCase();

    var strings =
      DICTIONARY[langCode] ||
      DICTIONARY.en;

    setText(
      container,
      '[data-delivery-label="ordered"]',
      strings.ordered
    );

    setText(
      container,
      '[data-delivery-label="ready"]',
      strings.ready
    );

    setText(
      container,
      '[data-delivery-label="delivered"]',
      strings.delivered
    );

    var countryName = currentCountry;

    try {
      if (
        window.Intl &&
        Intl.DisplayNames
      ) {
        countryName =
          new Intl.DisplayNames(
            [currentLocale],
            { type: 'region' }
          ).of(currentCountry) ||
          currentCountry;
      }
    } catch (error) {
      countryName = currentCountry;
    }

    renderDestination(
      container,
      strings.freeShip,
      countryName
    );

    var transitMin = 1;
    var transitMax = 10;

    if (
      GROUP_AT_SI.indexOf(currentCountry) !== -1
    ) {
      transitMin = 1;
      transitMax = 3;
    } else if (
      GROUP_EU.indexOf(currentCountry) !== -1
    ) {
      transitMin = 1;
      transitMax = 5;
    } else if (
      GROUP_EUROPE.indexOf(currentCountry) !== -1
    ) {
      transitMin = 1;
      transitMax = 7;
    }

    var today = new Date();

    var readyMin = addBusinessDays(
      today,
      HANDLING_MIN
    );

    var readyMax = addBusinessDays(
      today,
      HANDLING_MAX
    );

    var deliverMin = addBusinessDays(
      readyMax,
      transitMin
    );

    var deliverMax = addBusinessDays(
      readyMax,
      transitMax
    );

    var formatter = new Intl.DateTimeFormat(
      currentLocale,
      {
        month: 'short',
        day: 'numeric'
      }
    );

    var readyMinText = formatter.format(readyMin);
    var readyMaxText = formatter.format(readyMax);

    setText(
      container,
      '[data-delivery-date="ordered"]',
      formatter.format(today)
    );

    setText(
      container,
      '[data-delivery-date="ready"]',
      readyMinText === readyMaxText
        ? readyMaxText
        : readyMinText + ' - ' + readyMaxText
    );

    setText(
      container,
      '[data-delivery-date="delivered"]',
      formatter.format(deliverMin) +
        ' - ' +
        formatter.format(deliverMax)
    );

    container.dataset.deliveryTimelineReady =
      'true';
  }

  function initAll(scope) {
    var root =
      scope && scope.querySelectorAll
        ? scope
        : document;

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches(SELECTOR)
    ) {
      init(root);
    }

    root
      .querySelectorAll(SELECTOR)
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      },
      { once: true }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);
    }
  );
})();